export const PREGUNTA_PADRE = 0;
